import { isProd } from './env';
import { isUrl } from '../../common/utils';

export function safeImportMetaUrl(): URL | null {
    /**
     * Important: when not using prod build, we always assume we are in dev mode.
     * In dev mode we cannot reference `import.meta.url` because when `webpack`
     * is configured with `eval-*` type source maps it causes exceptions.
     */
    if (!isProd) return null;

    /**
     * NOTE: we originally want to just use `new URL(import.meta.url)`,
     * but we can't because of library multiple build targets.
     *
     * `import.meta.url` needs to be used only in browser bundle builds,
     * but due to the fact browser bundles are created by webpack bundling the rollup dist first,
     * it is easier to add `import.meta.url` using webpack plugin instead of
     * removing it with rollup based on build target. Leaving `import.meta.url`
     * in rollup dist (library output) would crash all webpack4 apps.
     *
     * "'<WEBPACK_REPLACE_IMPORT_META_URL>'" is being replaced to `import.meta.url`
     * by webpack when creating browser bundle.
     */
    const importMetaUrl = '<WEBPACK_REPLACE_IMPORT_META_URL>';

    if (!isUrl(importMetaUrl)) return null;

    return new URL(importMetaUrl);
}
